import {
    ORDERLOCATIONS_LOADING, SET_ORDERLOCATIONS, ORDERLOCATIONS_SUCCESS, ORDERLOCATIONS_ERROR
} from "../actions/actionOrderLocations";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "orderLocations";
const sessionKey2 = "orderLocation";

const initialState = {
    orderLocations: loadState(sessionKey, []),
    orderLocation: loadState(sessionKey2, null),
    loading: false,
    error: ''
};

function reducerOrderLocations(state = initialState, action) {
    switch (action.type) {
        case ORDERLOCATIONS_LOADING: {
            return {
                ...state,
                loading: true,
                error: ''
            };
        }

        case ORDERLOCATIONS_SUCCESS: {

            let orderLocations = [
                ...action.payload
            ]

            saveState(sessionKey, orderLocations);

            return {
                ...state,
                orderLocations: orderLocations,
                loading: false,
                error: ''
            };
        }
        case SET_ORDERLOCATIONS: {

            let orderLocation = {
                ...action.payload
            }

            saveState(sessionKey2, orderLocation);

            return {
                ...state,
                orderLocation: orderLocation
            };
        }
        case ORDERLOCATIONS_ERROR: {

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            return {
                ...state,
                loading: false,
                error: error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerOrderLocations;